import useAppQuery from 'core/query-client/useAppQuery';
import { getSites } from 'shared/api/projects/http';

const useSitesQuery = (payload) => useAppQuery(['sites', payload], () => getSites(payload));

export default useSitesQuery;
